<div class="lv-modal-dialog">
  <div mat-dialog-title class="lv-dialog-header">
    <div class="lv-dialog-header-title">
      {{ data.titel }}
    </div>
    <div class="lv-dialog-icon-close">
      <mat-icon [svgIcon]="'Times'" (click)="abbrechenButtonClicked()"></mat-icon>
    </div>
  </div>
  <div mat-dialog-content class="lv-dialog-content">
    {{ data.content }}
  </div>
  <div mat-dialog-actions class="lv-dialog-footer" align="end">
    <button mat-raised-button *ngIf="!!data.bezAbbrechenButton" color="accent" (click)="abbrechenButtonClicked()">
      {{ data.bezAbbrechenButton }}
    </button>
    <button mat-raised-button *ngIf="!!data.bezWeiterButton" color="primary" (click)="weiterButtonClicked()">
      {{ data.bezWeiterButton }}
    </button>
  </div>
</div>
